import React from "react";
import { Link, withRouter } from "react-router-dom";
import { createUseStyles } from "react-jss";
import { pipe } from "Utils/index";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import TagListContainer from "Containers/TagsList/TagsListContainer";
import Button from "ComponentsUI/Button";
import TagsListWrapper from "ComponentsUI/TagsListWrapper";

const useStyles = createUseStyles((theme) => ({
	root: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: "40px",
	},
	buttonFeedback: {
		// margin: "0 20px",
	},
	tagsList: {},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			flexDirection: "column",
		},
		buttonFeedback: {
			width: "100%",
			margin: "20px 0",
		},
		tagsList: {
			display: "flex",
			justifyContent: "space-between",
		},
	},
}));

const ControlFilter = (props) => {
	const classes = useStyles();

	let feedbackUrl = generateUrl(Routes.AddReview.route, {
		regionUrl: props.match.params.regionUrl,
	});

	return (
		<>
			<div className={classes.root}>
				<TagsListWrapper>
					<TagListContainer isProviderReviews={true} />
				</TagsListWrapper>
				<div className={classes.buttonFeedback}>
					<Button
						typeText="big"
						component={<Link to={!!feedbackUrl ? feedbackUrl : "/"} />}
						size={"middle"}
						status={"tertiaryAccent"}
						datatest="providers_reviews_feedback_button"
						fullWidth={true}
					>
						{props.text.ratingLeaveReview}
					</Button>
				</div>
			</div>
		</>
	);
};

export default pipe(withRouter)(ControlFilter);
